import userLocation from 'assets/userLocation.svg'
import { Icon } from 'leaflet'

export const locationIcon = new Icon({
  iconUrl: userLocation,
  iconAnchor: [15, 25],
  iconSize: [30, 50],
})